import cx from 'classnames';
import _ from 'lodash';
import React from 'react';
// eslint-disable-next-line import/no-cycle
import { Accordion } from '../accordion';
import styles from '../accordion.module.scss';
import { AccordionList, } from '../accordion-list/accordion-list';
import { AccordionVariant } from '../types';
import { AccordionHeader } from './accordion-header';
export const AccordionItem = ({ children, header, displayHeader = true, description = '', headerTooltip = '', disabledTooltip = '', disabled = false, actionButtons = [], isExpanded = false, index = NaN, onItemClicked = _.noop, className = '', headerClassName = '', variant = AccordionVariant.BASIC, actionButtonsAlwaysVisible = false, noPadding = false, alignToHeader, // Don't set default here -- it's calculated below
onDisableItemClicked = _.noop, headerTitleRef = null, isExpandedWhenDisabled = false, noScrollInAccordian = false, ...restProps }) => {
    const toggleItem = () => {
        if (!disabled) {
            onItemClicked(index);
        }
    };
    const accordionItemChildrenType = children === null || children === void 0 ? void 0 : children.type;
    const isNestedAccordion = accordionItemChildrenType === Accordion ||
        accordionItemChildrenType === AccordionList ||
        variant === AccordionVariant.MULTI_LEVEL;
    // Use "alignToHeader" prop if it is passed in.
    // If not passed in, set default values as follows:
    // - nested accordions    => false
    // - all other accordions => true
    const shouldAlignToHeader = alignToHeader !== undefined ? alignToHeader : !isNestedAccordion;
    const isItemsExpanded = disabled ? isExpandedWhenDisabled : isExpanded;
    const accordionItemChildrenClass = cx(styles.accordionItemContent, styles[`accordion-${isItemsExpanded ? 'expanded' : 'collapsed'}`], {
        // Align accordion content with header text
        [styles.alignToHeader]: shouldAlignToHeader,
        // Applies padding-left: 0 for nested accordions
        // Only applied if "alignToHeader" prop is not present or if false
        [styles.noLeftPadding]: !alignToHeader && isNestedAccordion,
        [styles.noRightPadding]: isNestedAccordion,
        [styles.noPadding]: noPadding,
        [styles.accordionExpandedNoScroll]: noScrollInAccordian,
    });
    return (React.createElement("div", { className: cx(className, styles.accordionItem, {
            [styles.accordionItemDisabled]: disabled,
        }), ...restProps },
        displayHeader && (React.createElement(AccordionHeader, { header: header, description: description, headerTooltip: disabled ? disabledTooltip : headerTooltip, toggleClass: isItemsExpanded ? 'expanded' : 'collapsed', actionButtons: actionButtons.slice(0, 2), onClick: disabled ? onDisableItemClicked : toggleItem, className: headerClassName, variant: variant, actionButtonsAlwaysVisible: actionButtonsAlwaysVisible, headerTitleRef: headerTitleRef, disabled: disabled })),
        React.createElement("div", { className: accordionItemChildrenClass }, children)));
};
//# sourceMappingURL=accordion-item.js.map